module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "page-content"
  }, [_c('page-nav-bar', {
    attrs: {
      "currentServiceName": "MoneyRoad",
      "subNavTitle": "Import account report",
      "returnPreviousPage": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row rowBackgroundImage marginTopList"
  }), _vm._v(" "), _c('div', {
    staticClass: "layoutSubtitle"
  }), _vm._v(" "), _c('f7-list', {
    staticClass: "searchbar-not-found"
  }, [_c('f7-list-item', {
    attrs: {
      "title": "Nothing found"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "webdatalist"
  }, [_c('f7-list', {
    staticClass: "searchbar-found polsize",
    attrs: {
      "id": "bank-list"
    }
  }, _vm._l((this.report), function(account) {
    return _c('f7-list-item', {
      key: account.line,
      staticClass: "bankAccountList boxRequest",
      attrs: {
        "media": '<i class=\'icon list-icon ' + _vm.getClassStatus(account.status) + '\'></i>',
        "title": account.line + ': ' + account.name,
        "subtitle": account.status
      }
    }, [_vm._v(_vm._s(account.description) + "\n        ")])
  }), 1)], 1)], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-a8660e88", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a8660e88","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/bankAccounts/CMImportBankAccountReport.vue
// module id = 1706
// module chunks = 2